/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_Item_2Inputs */

const es_tyc_description_item_2 = /** @type {(inputs: Tyc_Description_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Outlook, OneDrive`)
};

const en_tyc_description_item_2 = /** @type {(inputs: Tyc_Description_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Outlook, OneDrive`)
};

/**
* | output |
* | --- |
* | "Microsoft Outlook, OneDrive" |
*
* @param {Tyc_Description_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_item_2 = /** @type {((inputs?: Tyc_Description_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_item_2(inputs)
	return en_tyc_description_item_2(inputs)
});
export { tyc_description_item_2 as "tyc.description.item_2" }